import React from 'react';
import PriceLoader from '../UI/Price/PriceLoader';
import { currencyFormatter } from '@mooncake/utils/sfcc/currency';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

interface IFixedPriceProps {
  price: number;
  width?: number;
  fill?: string;
}

const Fixedprice = ({
                      price,
                      width = 50,
                      fill = '#35C1CF'
                    }: IFixedPriceProps) => {
  const app = useSelector((state: RootState) => state.app);
  const { loading, config } = app;

  if (loading) {
    return <PriceLoader fill={fill} width={width} height={width} />;
  }

  const localeIdFormatted =
    config.localeId.indexOf('_') > 0
      ? config.localeId.replace('_', '-').toLowerCase()
      : config.localeId;
  const displayPrice = currencyFormatter(
    price,
    localeIdFormatted,
    config.currency
  );

  return <div className='fixed-price'>{displayPrice}</div>;
};

export default Fixedprice;
